import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { AlchamisMark } from "@/components/AlchamisMark";

export default function NotFound() {
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 pt-32 pb-24" data-testid="not-found">
      <Seo title="Page not found" noindex />
      <div className="max-w-xl text-center">
        <AlchamisMark size={48} />
        <div className="overline mt-6">404 — Off the path</div>
        <h1 className="font-display text-5xl sm:text-6xl text-[#001B54] mt-6 leading-tight">
          The page you sought is
          <span className="block italic gold-text">no longer in this corridor.</span>
        </h1>
        <p className="text-[#3F4A6B] mt-6">Return to the public site or reach our office directly.</p>
        <div className="mt-10 flex justify-center gap-3 flex-wrap">
          <Link to="/" className="luxury-button">Return Home</Link>
          <Link to="/contact" className="luxury-button-ghost">Contact Office</Link>
        </div>
      </div>
    </div>
  );
}
